import store from '../store'

export const processingApi = {
  show() {
    store.commit('SET_PROCESSING', true)
  },
  showModal(text) {
    store.commit('SET_SHOW_MODAL', true)
    store.commit('SET_OVERLAY_TEXT', text)
  },
  hideAll() {
    store.commit('SET_PROCESSING', false)
    store.commit('SET_SHOW_MODAL', false)
    store.commit('SET_OVERLAY_TEXT', '')
  }
}